import React from "react";
import Select from "react-select";
import "./PodiumDropdown.css";

const PodiumDropdown = ({ podiums = [], selectedPodiumId, onChange, label = "Select Podium:", className = "" }) => {
    const options = podiums.map((podium) => ({
        value: podium.id,
        label: podium.name,
    }));

    const selectedOption = options.find((opt) => opt.value === selectedPodiumId);

    return (
        <div className={`dashboard-podium-form ${className}`}>
            <label className="dashboard-podium-label">{label}</label>
            <div className="dashboard-podium-select-container">
                <Select
                    options={options}
                    value={selectedOption}
                    onChange={(opt) => onChange(opt.value)}
                    classNamePrefix="react-select"
                    menuPlacement="auto"
                    isSearchable
                />
            </div>
        </div>
    );
};

export default PodiumDropdown;
